<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['general-stats-head-title']"
    :description="propsdata[0]['translation']['general-stats-head-description']"
/>

    <div v-if="!todocargado" style="margin-top: 150px;">
      <lottie-player src="https://qr.io/lottie/qr-loading.json" background="transparent" speed="1" style="width: 230px; height: 230px; margin: 0 auto;" loop autoplay></lottie-player>
    </div>

    <div v-if="todocargado" class="content2 setmargin pt-md-5">
      <div v-show="demo_banner === true" v-if="demo_banner === true" style="display:none;">
        <div role="alert" class="alert alert-secondary alert-dismissible fade show mb-0 classdefranco" style="margin-top:40px;display: flex;justify-content: center;background-color: rgb(1, 70, 119);border-color: rgb(1, 70, 119);padding: 1.5rem;">
          <span class="alert-inner--text" style="font-size: 18px; line-height: 42px;">{{propsdata[0]['translation']['general-stats-demo-title']}}</span>
          <router-link :to="'/dashboard/example-stats?ref='+stats[0].qrid" class="btn btn-white btn_del_continue animate-up-2 ml-3">{{propsdata[0]['translation']['general-stats-demo-button']}}</router-link>
          <button @click="hide_demo" class="close"><span>×</span></button>
        </div>
      </div>

      <section class="pt-3 pt-md-5 pb-3">
        <div class="container px-0 px-md-3">
          <div class="card-group align-items-center rounded bg-white" style="box-shadow: rgba(0, 64, 128, 0.2) 0px 10px 40px -10px;">
            <div class="card">
              <div class="card-body text-center">
                <h6 class="font-weight-bold mb-2" style="margin-bottom: 0px!important;">{{propsdata[0]['translation']['general-stats-total-qr-codes']}}</h6>
                <h5 class="text-gray mb-0"><span class="icon-danger mr-2"><i class="fas fa-long-arrow-alt-up" style="color: rgb(21, 169, 124);"></i></span><span class="mr-2">{{stats[0].account_totalqrcodes}}</span></h5>
              </div>
            </div>
            <div class="card">
              <div class="card-body text-center">
                <h6 class="font-weight-bold mb-2">{{propsdata[0]['translation']['general-stats-total-scans']}}</h6>
                <h5 class="text-gray mb-0"><span class="mr-2">{{stats[0].account_totalscans}}</span></h5>
              </div>
            </div>
            <div class="card">
              <div class="card-body text-center">
                <h6 class="font-weight-bold mb-2">{{propsdata[0]['translation']['general-stats-total-unique-scans']}}</h6>
                <h5 class="text-gray mb-0"><span class="mr-2">{{stats[0].account_unique_totalscans}}</span></h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="container px-0 px-md-3">
        <div class="mb-3">
          <div>
            <label>{{propsdata[0]['translation']['general-stats-date-range']}}</label>
            <select v-model="range" style="width: 200px;display: block;" class="custom-select">
              <option value="all time">
                {{propsdata[0]['translation']['general-stats-all-time']}}
              </option>
              <option value="last 30 days">
                {{propsdata[0]['translation']['general-stats-last-30-days']}}
              </option>
              <option value="custom">
                {{propsdata[0]['translation']['general-stats-custom']}}
              </option>
            </select>
            <div v-if="range === 'custom'" class="d-flex">
              <div class="col-6 pl-0 pr-2">
                <label class="h6 mt-3 mb-1">{{propsdata[0]['translation']['general-stats-from']}}</label>
                <div class="input-group">
                    <span class="bg-white border rounded-left border-right-0" style="height: 43.6px; padding: 9px;"><i class="fas far fa-calendar-alt"></i></span>
                    <input v-model="from" type="date" class="form-control" style="height: 43.6px;">
                </div>
              </div>
              <div class="col-6 pr-0 pl-2">
                <label class="h6 mt-3 mb-1">{{propsdata[0]['translation']['general-stats-to']}}</label>
                  <div class="input-group">
                    <span class="bg-white border rounded-left border-right-0" style="height: 43.6px; padding: 9px;"><i class="fas far fa-calendar-alt"></i></span>
                    <input v-model="to" type="date" class="form-control" style="height: 43.6px;">
                  </div>
              </div>
            </div>
            <p v-if="pickdays" class="mb-0 mt-2">{{propsdata[0]['translation']['general-stats-pick']}}</p>
          </div>
        </div>
        <div class="d-flex flex-wrap">
          <!-- Blog Card -->
          <div class="col-lg-6 px-0 pr-lg-2 pb-3">
            <div class="card shadow-soft border-light">
              <div class="card-header">
                <div class="d-md-flex justify-content-between align-items-center">
                  <h6 class="icon-info" style="margin: 0;"><i class="fas fa-code mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-1-title']}} ({{range}})</h6>
                </div>
              </div>
              <div class="card-body pt-0">
                <div v-if="loading">
                  <div class="item block preload" style="z-index: 1;width: 100%; padding: 0;">
                    <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1"><stop stop-color="#E5EBEE" offset="0%"></stop> <stop stop-color="#F4F4F4" offset="100%"></stop></linearGradient></defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="image"><rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect> <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect> <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect></g></g></svg>
                  </div>
                </div>
                <apexchart v-if="!loading && !novisits_chart1" width="100%" type="bar" :options="{
                  chart: {
                    id: 'scans',
                    zoom: {
                      enabled: false
                    },
                    toolbar: {
                      show: true,
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  stroke: {
                    curve: 'smooth'
                  },
                  grid: {
                    show: true,
                  },
                  xaxis: {
                    type: 'datetime',
                    categories: statsfecha,
                    labels: {
                      show: true
                    }
                  },
                  yaxis: {
                    show: true,
                    opposite: false
                  },
                  }" 
                  :series="[
                    {
                      name: 'Total Scans',
                      data: statsvisits
                    },
                    {
                      name: 'Unique Scans',
                      data: statsunique
                    }
                  ]">
                </apexchart>
                <p v-if="!loading && novisits_chart1" style="text-align: center; margin-top: 138px; font-weight: 700; margin-bottom: 138px;">{{propsdata[0]['translation']['general-stats-chart-1-nodata']}}</p>
              </div>
            </div>
          </div>
          <!-- End of Blog Card -->
          <!-- Blog Card -->
          <div class="col-lg-6 px-0 pl-lg-2 pb-3">
            <div class="card shadow-soft border-light">
              <div class="card-header">
                <div class="d-md-flex justify-content-between align-items-center">
                  <h6 class="icon-info" style="margin: 0;color: #15a97c;"><i class="fas fa-code mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-2-title']}} ({{range}})</h6>
                  <button @click="ExportStats('os')" class="btn btn-sm btn-outline-gray mt-2 mt-md-0"><i class="fas fa-file-download mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-2-export']}}</button>
                </div>
              </div>
              <div class="card-body pt-0">
                <div v-if="loading">
                  <div class="item block preload" style="z-index: 1;width: 100%; padding: 0;">
                    <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1"><stop stop-color="#E5EBEE" offset="0%"></stop> <stop stop-color="#F4F4F4" offset="100%"></stop></linearGradient></defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="image"><rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect> <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect> <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect></g></g></svg>
                  </div>
                </div>
                <!--MDB Tables-->
                <div v-if="!loading">
                  <div class="card" style="padding: 0;">
                    <div style="overflow: auto;height: 309px;">
                      <!--Table-->
                      <table class="table table-hover" style="margin-bottom:0;">
                        <!--Table head-->
                        <thead class="mdb-color darken-3" style="background: #15a97c;">
                          <tr class="text-white">
                            <th>#</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-2-col-os']}}</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-2-col-scans']}}</th>
                            <th>%</th>
                          </tr>
                        </thead>
                        <!--Table head-->
                        <!--Table body-->
                        <tbody>
                          <tr v-for="(os, index) in stats[0].stats_os">
                            <th scope="row">{{index + 1}}</th>
                            <td>{{os.os}}</td>
                            <td>{{os.visits}}</td>
                            <td>{{os.percentage}}</td>
                          </tr>
                        </tbody>
                        <!--Table body-->
                      </table>
                      <p v-if="!loading && stats[0].stats_os === null" style="text-align:center;margin-top: 70px;font-weight:700;">{{propsdata[0]['translation']['general-stats-chart-2-nodata']}}</p>
                      <!--Table-->
                    </div>
                  </div>
                </div>
                <!--MDB Tables-->
              </div>
            </div>
          </div>
          <!-- End of Blog Card -->
          <!-- Blog Card -->
          <div class="col-lg-6 px-0 pr-lg-2 pb-3">
            <div class="card shadow-soft border-light">
              <div class="card-header">
                <div class="d-md-flex justify-content-between align-items-center">
                  <h6 class="icon-info" style="margin: 0;color: #15a97c;"><i class="fas fa-code mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-3-title']}} ({{range}})</h6>
                  <button @click="ExportStats('countries')" class="btn btn-sm btn-outline-gray mt-2 mt-md-0"><i class="fas fa-file-download mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-3-export']}}</button>
                </div>
              </div>
              <div class="card-body pt-0">
                <div v-if="loading">
                  <div class="item block preload" style="z-index: 1;width: 100%; padding: 0;">
                    <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1"><stop stop-color="#E5EBEE" offset="0%"></stop> <stop stop-color="#F4F4F4" offset="100%"></stop></linearGradient></defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="image"><rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect> <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect> <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect></g></g></svg>
                  </div>
                </div>
                <!--MDB Tables-->
                <div v-if="!loading">
                  <div class="card" style="padding: 0;">
                    <div style="overflow: auto;height: 309px;">
                      <!--Table-->
                      <table class="table table-hover" style="margin-bottom:0;">
                        <!--Table head-->
                        <thead class="mdb-color darken-3" style="background: #15a97c;">
                          <tr class="text-white">
                            <th>#</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-3-col-country']}}</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-3-col-scans']}}</th>
                            <th>%</th>
                          </tr>
                        </thead>
                        <!--Table head-->
                        <!--Table body-->
                        <tbody>
                          <tr v-for="(country, index) in stats[0].statscountry">
                            <th scope="row">{{index + 1}}</th>
                            <td><img v-if="country.country !== 'XX'" :src="'https://qr.io/flags/'+country.country+'.svg'" style="width: 23px;margin-right: 12px;position: relative;top: -3px;">{{country.countryname}}</td>
                            <td>{{country.visits}}</td>
                            <td>{{country.percentage}}</td>
                          </tr>
                        </tbody>
                        <!--Table body-->
                      </table>
                      <p v-if="!loading && stats[0].statscountry === null" style="text-align:center;margin-top: 70px;font-weight:700;">{{propsdata[0]['translation']['general-stats-chart-3-nodata']}}</p>
                      <!--Table-->
                    </div>
                  </div>
                </div>
                <!--MDB Tables-->
              </div>
            </div>
          </div>
          <!-- End of Blog Card -->
          <!-- Blog Card -->
          <div class="col-lg-6 px-0 pl-lg-2 pb-3">
            <div class="card shadow-soft border-light">
              <div class="card-header">
                <div class="d-md-flex justify-content-between align-items-center">
                  <h6 class="icon-info" style="margin: 0;color: #15a97c;"><i class="fas fa-code mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-4-title']}} ({{range}})</h6>
                  <button @click="ExportStats('cities')" class="btn btn-sm btn-outline-gray mt-2 mt-md-0"><i class="fas fa-file-download mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-4-export']}}</button>
                </div>
              </div>
              <div class="card-body pt-0">
                <div v-if="loading">
                  <div class="item block preload" style="z-index: 1;width: 100%; padding: 0;">
                    <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1"><stop stop-color="#E5EBEE" offset="0%"></stop> <stop stop-color="#F4F4F4" offset="100%"></stop></linearGradient></defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="image"><rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect> <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect> <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect></g></g></svg>
                  </div>
                </div>
                <!--MDB Tables-->
                <div v-if="!loading">
                  <div class="card" style="padding: 0;">
                    <div style="overflow: auto;height: 309px;">
                      <!--Table-->
                      <table class="table table-hover" style="margin-bottom:0;">
                        <!--Table head-->
                        <thead class="mdb-color darken-3" style="background: #15a97c;">
                          <tr class="text-white">
                            <th>#</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-4-col-city']}}</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-4-col-scans']}}</th>
                            <th>%</th>
                          </tr>
                        </thead>
                        <!--Table head-->
                        <!--Table body-->
                        <tbody>
                          <tr v-for="(city, index) in stats[0].statscity">
                            <th scope="row">{{index + 1}}</th>
                            <td>{{city.city}}</td>
                            <td>{{city.visits}}</td>
                            <td>{{city.percentage}}</td>
                          </tr>
                        </tbody>
                        <!--Table body-->
                      </table>
                      <p v-if="!loading && stats[0].statscity === null" style="text-align:center;margin-top: 70px;font-weight:700;">{{propsdata[0]['translation']['general-stats-chart-4-nodata']}}</p>
                      <!--Table-->
                    </div>
                  </div>
                </div>
                <!--MDB Tables-->
              </div>
            </div>
          </div>
          <!-- End of Blog Card -->
          <!-- Blog Card -->
          <div class="col-lg-12 px-0 pb-3">
            <div class="card shadow-soft border-light">
              <div class="card-header">
                <div class="d-md-flex justify-content-between align-items-center">
                  <h6 class="icon-info" style="margin: 0;color: #15a97c;"><i class="fas fa-code mr-2"></i>{{propsdata[0]['translation']['general-stats-chart-5-title']}} ({{range}})</h6>
                </div>
              </div>
              <div class="card-body pt-0">
                <div v-if="loading">
                  <div class="item block preload" style="z-index: 1;width: 100%; padding: 0;">
                    <svg viewBox="0 0 350 245" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1"><stop stop-color="#E5EBEE" offset="0%"></stop> <stop stop-color="#F4F4F4" offset="100%"></stop></linearGradient></defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="image"><rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="216" width="350" height="13" rx="6.5"></rect> <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="232" width="203" height="13" rx="6.5"></rect> <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="350" height="203" rx="6"></rect></g></g></svg>
                  </div>
                </div>
                <!--MDB Tables-->
                <div v-if="!loading">
                  <div class="card" style="padding: 0;">
                    <div style="overflow: auto;height: 309px;">
                      <!--Table-->
                      <table class="table table-hover" style="margin-bottom:0;">
                        <!--Table head-->
                        <thead class="mdb-color darken-3" style="background: #15a97c;">
                          <tr class="text-white">
                            <th>{{propsdata[0]['translation']['general-stats-chart-5-col-id']}}</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-5-col-name']}}</th>
                            <th>{{propsdata[0]['translation']['general-stats-chart-5-col-scans']}}</th>
                            <th>%</th>
                          </tr>
                        </thead>
                        <!--Table head-->
                        <!--Table body-->
                        <tbody>
                          <tr v-for="(qr, index) in stats[0].byqr">
                            <th scope="row"><router-link :to="'/dashboard/stats/'+qr.qrid" style="text-decoration: underline;">{{qr.qrid}}</router-link></th>
                            <td>{{qr.titulo}}</td>
                            <td>{{qr.visits}}</td>
                            <td>{{qr.percentage}}</td>
                          </tr>
                        </tbody>
                        <!--Table body-->
                      </table>
                      <p v-if="!loading && stats[0].qrs === null" style="text-align:center;margin-top: 70px;font-weight:700;">{{propsdata[0]['translation']['general-stats-chart-5-nodata']}}</p>
                      <!--Table-->
                    </div>
                  </div>
                </div>
                <!--MDB Tables-->
              </div>
            </div>
          </div>
          <!-- End of Blog Card -->
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .item{
    border-radius: 8px;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
    animation-name: item;
    animation-duration: 0.4s;
    display: inline-block;
    text-align: left;
    animation-fill-mode: backwards;
  }
  .preload:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    background: linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));
    -webkit-animation: _1IOU .8s linear infinite;
    animation: _1IOU .8s linear infinite;
  }
</style>

<script>
  export default {
    props:['propsdata'],
    data() {
      return {
        todocargado: false,
        demo_banner: false,
        timenow: Date.now(),
        loading: true,
        stats: [],
        statsfecha: [],
        statsvisits: [],
        statsunique: [],
        novisits_chart1: false,
        range: 'last 30 days',
        from: '',
        to: '',
        pickdays: false
      };
    },
    methods: {
      hide_demo(){
        this.$cookies.set("hide_demo", "yes", 60 * 60 * 24 * 30, "/dashboard", "qr.io"); // 1 month after, expire
        this.demo_banner = false;
      },
      cargar(){
        this.loading = true;
        axios.post('/dashboard/cargar-general-stats.php', {
          range: this.range,
          from: this.from,
          to: this.to
        })
        .then(response => {
          if(response.data == 'no pago'){
            window.location.href = "https://qr.io/choose-plan/"+this.propsdata[0].unique_id+"?utm_campaign=dashboard";
          }
          else if(response.data == 'canceled_due_attempt2'){
            window.location.href = "https://qr.io/dashboard/billing";
          }
          else if(response.data == 'not his qr code'){
            this.$router.push('/dashboard/');
          }
          else{
            this.loading = false;
            this.stats = response.data;
            this.statsfecha = [];
            this.statsvisits = [];
            this.statsunique = [];
            var arr = response.data[0].stats;
            if(arr !== null){
              var contar = arr.length;
              // console.log(contar);
              var num = 0;
              while(num < contar){
                this.statsfecha.push(response.data[0].stats[num].fecha);
                this.statsvisits.push(response.data[0].stats[num].visits);
                this.statsunique.push(response.data[0].stats[num].unique);
                num++;
              }
              this.novisits_chart1 = false;
            }
            else{
              this.novisits_chart1 = true;
            }
            this.todocargado = true;
            if(this.$cookies.get("hide_demo") != 'yes' && response.data[0].account_totalscans < 5){
              this.demo_banner = true;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      ExportStats(cuales){
        if(this.range == 'custom' && (this.from == '' || this.to == '')){
          this.pickdays = true;
          return; // If the range is custom and the from or to is empty, do nothing
        }
        axios.post('/dashboard/export-general-stats.php', {
          range: this.range,
          from: this.from,
          to: this.to,
          chart: cuales
        })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', cuales+'-stats-general.csv');
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    watch: {
      range(){
        if(this.range == 'all time'){
          this.cargar();
        }
        if(this.range == 'last 30 days'){
          this.cargar();
        }
      },
      from(){
        if(this.range == 'custom' && this.from != '' && this.to != ''){
          this.cargar();
          this.pickdays = false;
        }
      },
      to(){
        if(this.range == 'custom' && this.from != '' && this.to != ''){
          this.cargar();
          this.pickdays = false;
        }
      }
    },
    mounted() {
      this.cargar();
    }
  };
</script>



// WEBPACK FOOTER //
// src/general-stats.vue